'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UniqueSystemIngredientName = function () {
  function UniqueSystemIngredientName($q, SystemIngredientsService) {
    'ngInject';

    _classCallCheck(this, UniqueSystemIngredientName);

    Object.assign(this, {
      $q: $q,
      SystemIngredientsService: SystemIngredientsService
    });

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  _createClass(UniqueSystemIngredientName, [{
    key: 'link',
    value: function link($scope, element, attrs, ctrl) {
      var _this = this;

      var ingredientId = null;

      if (attrs.ingredientId) {
        ingredientId = attrs.ingredientId;
      }

      // Async validator requires resolve or reject to set validity
      ctrl.$asyncValidators.uniqueSystemIngredientName = function (ingredientName) {
        var defer = _this.$q.defer();

        _this.SystemIngredientsService.isUniqueIngredientName(ingredientName, ingredientId).then(function (r) {
          if (r.data) {
            defer.resolve();
          }

          defer.reject();
        }).catch(function () {
          return defer.reject();
        });

        return defer.promise;
      };
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory($q, SystemIngredientsService) {
      'ngInject';

      return new UniqueSystemIngredientName($q, SystemIngredientsService);
    }
  }]);

  return UniqueSystemIngredientName;
}();

exports.default = UniqueSystemIngredientName;


// WEBPACK FOOTER //
// ./common/directives/validation/unique-system-ingredient-name.js